@layer theme, base, components, utilities;
@import "tailwindcss/theme" layer(theme);
@import "tailwindcss/utilities" layer(utilities);

/* noinspection CssUnresolvedCustomProperty */
@theme {
  /* Brand colors mapped from Mantine */
  --color-brand-0: var(--mantine-color-brand-0);
  --color-brand-1: var(--mantine-color-brand-1);
  --color-brand-2: var(--mantine-color-brand-2);
  --color-brand-3: var(--mantine-color-brand-3);
  --color-brand-4: var(--mantine-color-brand-4);
  --color-brand-5: var(--mantine-color-brand-5);
  --color-brand-6: var(--mantine-color-brand-6);
  --color-brand-7: var(--mantine-color-brand-7);
  --color-brand-8: var(--mantine-color-brand-8);
  --color-brand-9: var(--mantine-color-brand-9);

  /* Structural grays — mapped from our custom mgray Mantine color */
  --color-mgray-0: var(--mantine-color-mgray-0);
  --color-mgray-1: var(--mantine-color-mgray-1);
  --color-mgray-2: var(--mantine-color-mgray-2);
  --color-mgray-3: var(--mantine-color-mgray-3);
  --color-mgray-4: var(--mantine-color-mgray-4);
  --color-mgray-5: var(--mantine-color-mgray-5);
  --color-mgray-6: var(--mantine-color-mgray-6);
  --color-mgray-7: var(--mantine-color-mgray-7);
  --color-mgray-8: var(--mantine-color-mgray-8);
  --color-mgray-9: var(--mantine-color-mgray-9);

  /* Semantic text colors */
  --color-text-0: var(--mantine-color-text-0);
  --color-text-2: var(--mantine-color-text-2);
  --color-text-4: var(--mantine-color-text-4);
  --color-text-6: var(--mantine-color-text-6);

  /* Status colors */
  --color-success: var(--mantine-color-success-6);
  --color-warning: var(--mantine-color-warning-6);
  --color-danger: var(--mantine-color-danger-6);

  /* Spacing mapped from Mantine */
  --spacing-mxs: var(--mantine-spacing-xs);
  --spacing-msm: var(--mantine-spacing-sm);
  --spacing-mmd: var(--mantine-spacing-md);
  --spacing-mlg: var(--mantine-spacing-lg);
  --spacing-mxl: var(--mantine-spacing-xl);
}

/* ─── Focus ring — style guide spec ─────────────────────────────────────────
   1.5 px Main Blue border + 3 px Blue Highlight 2 halo (WCAG 2.4.7 / 2.4.11)  */
*:focus {
  outline: none;
}

*:focus-visible {
  outline: 1.5px solid #003591;
  outline-offset: 0;
  box-shadow: 0 0 0 3px #DBEBF2;
}
